import { KeycloakInstance } from 'keycloak-js';

// eslint-disable-next-line import/no-cycle
import { Authenticated } from '../app/AuthorizationProvider';
import { DEFAULT_LOCALE } from '../translations/i18n';

export const authenticatedStateMock: Authenticated = {
  status: 'authenticated',
  logout: () => null,
  forceUpdateToken: async () => Promise.resolve(true),
  isTokenInvalid: () => false,
  keycloak: null as unknown as KeycloakInstance,
  locale: DEFAULT_LOCALE,
  manageAccountUrl: '/',
  userHasPermissions: () => false,
  userId: 'abcde',
  userName: '',
  timezone: 'Europe/Bratislava',
  sessionIdleTimeDuration: 15 * 60 * 1000, // 15m in millis
};
